import type { UseApiClientReturn } from "@Front/Hooks/useApiClientTypes";
import { useApiErrorHandler } from "@Front/Hooks/useApiErrorHandler";
import { useApiExecuteRequest } from "@Front/Hooks/useApiExecuteRequest";
import { useApiSendAndCrud } from "@Front/Hooks/useApiSendAndCrud";

export function useApiRequestMethods(
	baseUrl: string,
	getAccessToken: (endpoint?: string) => string | null,
	getHeaders: (requireAuth?: boolean, additionalHeaders?: HeadersInit, endpoint?: string) => Headers,
): Pick<UseApiClientReturn, "get" | "post" | "put" | "delete"> {
	const handleApiError = useApiErrorHandler();
	const executeRequest = useApiExecuteRequest(handleApiError);
	return useApiSendAndCrud(baseUrl, getAccessToken, getHeaders, executeRequest);
}
